
import PieOfTheMonth from "pages/pie-of-the-month";
// import PieOfTheMonthDetails from "pages/pie-of-the-month/details";
// import PieOfTheMonthDetailComponent from "pages/pie-of-the-month/details/PieOfTheMonthDetailComponent";

const routes = [
  // home
  {
    path: `/pie-of-the-month`,
    exact: true,
    auth: true,
    component: PieOfTheMonth,
  },
  // //create
  // {
  //   path: `/pie-of-the-month/add`,
  //   exact: true,
  //   auth: true,
  //   component: PieOfTheMonthDetails,
  // },
  // //update
  // {
  //   path: `/pie-of-the-month/update`,
  //   exact: true,
  //   auth: true,
  //   component: PieOfTheMonthDetailComponent,
  // },
];

export default routes;
